(function () {
  // 作品（コレクション）のお気に入り。商品版 wishlist.js と同じ作法。
  // v1はlocalStorageのみ（App Proxy /apps/wishlist は商品専用のため同期なし＝端末ごと保存）
  const storeKey = 'wishlist_work_ids';

  function readLocal() {
    try { return JSON.parse(localStorage.getItem(storeKey) || '[]'); }
    catch { return []; }
  }
  function writeLocal(arr) {
    localStorage.setItem(storeKey, JSON.stringify([...new Set(arr.map(String))]));
  }
  function getState() { return new Set(readLocal().map(String)); }

  function setPressed(btn, active) {
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.title = active ? 'お気に入りから削除' : 'お気に入りに追加';
  }
  function refreshButtons() {
    const state = getState();
    document.querySelectorAll('.js-wishlist-work-btn').forEach(btn => {
      const id = (btn.getAttribute('data-collection-id') || '').toString();
      setPressed(btn, state.has(id));
    });
  }

  // --- 効果測定用: GA4イベント送信（theme.liquid のブリッジが gtag('event') へ転送） ---
  // 計測実装タスク 2026-08 / T2（お気に入りのGA4計測）
  function contextOf(btn) {
    if (!btn) return 'unknown';
    const explicit = btn.getAttribute('data-wishlist-context');
    if (explicit) return explicit;
    const sec = btn.closest('[data-section-type]');
    return (sec && sec.getAttribute('data-section-type')) || 'unknown';
  }
  function track(active, collectionId, btn) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: active ? 'add_to_wishlist_work' : 'remove_from_wishlist_work',
        work_id: String(collectionId),
        work_handle: (btn && btn.getAttribute('data-collection-handle')) || '',
        work_name: (btn && btn.getAttribute('data-collection-title')) || '',
        wishlist_context: contextOf(btn)
      });
    } catch (e) { /* 計測失敗で機能を止めない */ }
  }

  function toggle(collectionId, btn) {
    const id = String(collectionId);
    const arr = readLocal().map(String);
    const i = arr.indexOf(id);
    const added = i < 0;
    if (i >= 0) arr.splice(i, 1); else arr.push(id);
    writeLocal(arr);
    refreshButtons();
    track(added, id, btn);
    document.dispatchEvent(new CustomEvent('wishlist-works:change', { detail: { ids: readLocal() } }));
  }

  document.addEventListener('click', e => {
    const btn = e.target.closest('.js-wishlist-work-btn');
    if (!btn) return;
    e.preventDefault();
    toggle(btn.getAttribute('data-collection-id'), btn);
  });

  document.addEventListener('DOMContentLoaded', refreshButtons);

  // 一覧ページなどから使えるように公開
  window.WishlistWorks = { read: readLocal, refresh: refreshButtons };
})();
